import { getEnvConfig } from '@/utils/env-variables'

const freeze = Object.freeze

// Dánh sách app
const App = freeze({
  Student: 'student',
  Teacher: 'teacher',
  Account: 'account'
})

// Mã code HTTP response
const HttpStatusCode = freeze({
  OK: 200,
  Created: 201,
  BadRequest: 400,
  Unauthorized: 401,
  NotFound: 404,
  InternalServerError: 500,
  ServerMaintain: 503
})

// Các hành động dùng trong store
const Action = freeze({
  GET: 'get',
  ADD: 'add',
  UPDATE: 'update',
  DELETE: 'delete',
  SET: 'set'
})

//
const MaskTypes = freeze({
  DATE: 1,
  INTEGER: 2,
  FLOAT: 3
})

// Các phương thức HTTP
const HttpMethod = freeze({
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
  OPTION: 'OPTION',
  HEAD: 'HEAD'
})

// Dữ liệu truyền đi
const ContentType = freeze({
  ApplicationJsonUTF8: 'application/json; charset=utf-8',
  ApplicationJson: 'application/json',
  FormUrlEncoded: 'application/x-www-form-urlencoded',
  FormMultiPart: 'multipart/form-data'
})

const CookieType = freeze({
  DeviceId: '_device_id',
  RefreshToken: 'rft'
})

// Mã phím
const KeyboardCode = {
  ENTER: 13,
  BACKSPACE: 8,
  TAB: 9,
  INSERT: 45,
  DELETE: 46,
  ARROWLEFT: 37,
  ARROW_UP: 38,
  ARROWRIGHT: 39,
  ARROW_DOWN: 40,
  S: 83,
  CTRL_V: 86,
  NUMBER: [48, 57],
  WORD: [65, 122],
  NUMPAD: [96, 105],
  SHIFT: 16
}

const AssciCode = freeze({
  Upper: [65, 90]
})

// Các phương thức gửi OTP
const MethodSendOTP = freeze({
  App: 'App',
  Email: 'Email',
  PhoneNumber: 'PhoneNumber'
})

//
const FileExtensionType = freeze({
  Pdf: '.pdf',
  Doc: '.doc',
  Docx: '.docx',
  Ott: '.ott',
  Odt: '.odt',
  Xls: '.xls',
  Xlsx: '.xlsx',
  Ppt: '.ppt',
  Pptx: '.pptx',
  Odp: '.odp',
  Ods: '.ods',
  Xml: '.xml',
  Jpeg: '.jpeg',
  Jpg: '.jpg',
  Bmp: '.bmp',
  Png: '.png',
  Jfjf: '.jfif',
  Mp4: '.mp4',
  M4a: '.m4a',
  Mp3: '.mp3'
})

const MimeType = freeze({
  Pdf: 'application/pdf',
  Doc: 'application/msword',
  Docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  Png: 'image/png',
  Jpeg: 'image/Jpeg',
  Jpg: 'image/jpeg',
  Bmp: 'image/bmp',
  Xls: 'application/vnd.ms-excel',
  Xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
})

/**
 * Kiểu  người dùng
 */
const UserType = freeze({
  Teacher: 1, // Giáo viên
  Student: 5 // Học sinh
})

/** Thông tin này để dùng cho log fire base nên ko có localize  */
const UserTypeName = freeze({
  Teacher: 'Giáo viên', // Giáo viên
  Student: 'Học sinh' // Học sinh
})

/** Action log firebase */
const ActionTypeFireBase = freeze({
  View: 'View',
  Print: 'Print',
  Update: 'Update'
})

const NotifyIcon = freeze({
  Star: 'star',
  Practice: 'practice',
  Training: 'training'
})

const Regex = freeze({
  Email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PhoneNumber: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/,
  HasNumber: /\d/,
  HasUpper: /[A-Z]/,
  HasLower: /[a-z]/
})

const FileExtention = {
  Default: `.pdf,.doc,.docx
            ,.png,.jpg,.jpeg,.bmp
            ,.mp3,.mp4,.m4a
            ,.xls,.xlsx,.ppt,.pptx,.odp,.xmind,.mmap,.zip,.ods,.csv
            ,.7z,.rar,.html,.htm,.dwg,.dwf,.edb,.e2k,.msg,.odt,.rtf,.gif,.txt`,
  ImageOnly: '.png,.jpg,.jpeg,.bmp',
  ExcerciseUpload:
    '.png,.jpg,.jpeg,.bmp,.doc,.docx,.xls,.xlsx,.pdf,.mp3,.mp4,.m4a,.ppt,.pptx,.odp',
  UploadFileCompose: '.pdf,.doc,.docx',
  ImageAndVideo: '.png,.jpg,.jpeg,.bmp,.mp3,.mp4,.m4a',
  AudioAndVideo: '.mp3,.mp4,.m4a',
  Excel: '.xlsx,.xls',
  FileExtractToImage: '.pdf'
}

const QuestionType = {
  Select: 'Chọn đáp án', // Chọn đáp án
  Yesorno: 'Đúng sai', // Đúng sai
  Fill: 'Điền vào chỗ trống', // Điền từ
  Essay: 'Tự luận', // Tự luận
  Group: 'Câu hỏi nhóm' // Câu hỏi nhóm
}

const FileValidation = {
  MaxNumFile: getEnvConfig('maxNumFile'),
  MaxSizeFile: 10000, // không cho phép tải file quá 10.000Kb
  maxDurationFile: 60 // Thời lượng của file (giây)
}

const ActionGenLinkMisaId = freeze({
  Security: 'security', // Xem thông tin bảo mật (xác thực hai lớp, CMND)
  Index: 'index', // Vào trang home id.misa.vn (Thông tin tài khoản)
  ChangePassword: 'changepassword' // Vào trang đổi mật khẩu
})

const ReportIDs = freeze({
  ExamMakingProgressReport: 'ExamMakingProgressReport', // ID report tình trạng chấm bài
  ExamPeriodOverviewReport: 'ExamPeriodOverviewReport', // ID report màn tổng quan
  ExamPeriodReports: 'ExamPeriodReports' // ID report chi tiết thống kê
})

const ContextAuthCodeMisaID = freeze({
  Register: 'register',
  ForgotPassword: 'forgotpassword',
  TwoFactorAuthen: 'twoFactorAuthen',
  ConfirmAccount: 'confirmAccount'
})

const EventNameSocket = freeze({
  RingBell: 'ringBell',
  CloseExam: 'closeExam',
  OpenExam: 'openExam',
  JoinDate: 'joinDate',
  SubmitDate: 'submitDate',
  StudentIsReady: 'studentIsReady',
  StudentIsNotReady: 'studentIsNotReady',
  SendMark: 'sendMark',
  WithdrawMark: 'withdrawMark',
  LikeComment: 'likeComment',
  ReplyComment: 'replyComment',
  TagUser: 'tagUser',
  AutoJoinClassroomSuccess: 'autoJoinClassroomSuccess'
})

const ImportType = freeze({
  ExerciseStore: 'ExerciseStore'
})

const SocketEvent = freeze({
  Connection: 'connection',
  SendNotify: 'send_notify',
  NewNotify: 'new_notify',
  JoinRoom: 'join_room'
})

const AppNameFireBase = freeze({
  HomeWork: 'Ôn tập'
})

// Phân trang
const Pagination = freeze({
  PageSizeDefault: 30,
  PageIndexDefault: 1
})

const PlatformOnlineMeeting = freeze({
  MSTeam: 'Microsoft Teams',
  Zoom: 'Zoom Meetings',
  GGMeet: 'Google Meet'
})

const URLMeetingContain = freeze({
  MSTeam: 'teams.microsoft.com',
  Zoom: 'zoom.us'
})

const ExpectedActionRecaptcha = freeze({
  Login: 'login',
  Homepage: 'homepage',
  Social: 'social',
  ECommerce: 'e-commerce'
})

const AppCodeLicense = freeze({
  OT: 'OT',
  OTPRO: 'OTPRO'
})

const PlatformOnlineMeetingText = freeze({
  MSTeam: 'Teams',
  Zoom: 'Zoom',
  GGMeet: 'Google'
})

const InstallApp = freeze({
  Zoom: 'install-zoom'
})

const Version = freeze({
  V2: 'v2'
})

const TimerAnswerView = freeze({
  Select: 5,
  Fill: 3
})

const StarRanking = freeze({
  One: 25,
  Two: 20,
  Three: 15,
  Four: 12,
  Five: 10
})

// tỉ lệ tối đa nằm trong top học sinh chăm chỉ
const MAXIMUM_HARDWORKING_PERCENT = 20

// tỉ lệ đúng của môn học
const MaximumRatingSubject = freeze({
  Primary: 75,
  Default: 70
})
const HELP_LINK = freeze({
  SelfLearning: 'https://emishelp.misa.vn/kb/25626/'
})
const SCORE_EACH_QUESTION = 100 // điểm mặc định cho mỗi câu trong game Chiến binh thiên hà
const LESSON_TIME = 45 // thời gian 1 tiết học trung bình
const DEBOUNCE_TIME = 500 // nửa s

const CoverImageClassroomCount = 13 // Số lượng ảnh lớp đang có trong folder phục vụ việc render random ảnh lớp

const TIME_PLAY_GAME = 30 // Thời gian mặc định chơi game
const TIME_PLAY_GAME_FILL = 60 // Thời gian mặc định chơi game câu điền từ

export { App }
export { HttpStatusCode }
export { Action }
export { MaskTypes }
export { HttpMethod, ContentType }
export { CookieType }
export { QuestionType }
export { KeyboardCode }
export { ReportIDs }
export { MethodSendOTP }
export { ImportType }
export { UserType, UserTypeName }
export { ActionTypeFireBase }
export { FileExtensionType }
export { Regex }
export { ActionGenLinkMisaId }
export { ContextAuthCodeMisaID }
export { AssciCode }
export { FileExtention }
export { DEBOUNCE_TIME }
export { FileValidation }
export { AppNameFireBase }
export { Pagination }
export { EventNameSocket }
export { SocketEvent }
export { CoverImageClassroomCount }
export { PlatformOnlineMeeting }
export { URLMeetingContain }
export { ExpectedActionRecaptcha }
export { AppCodeLicense }
export { LESSON_TIME }
export { PlatformOnlineMeetingText }
export { InstallApp }
export { Version }
export { TimerAnswerView }
export { SCORE_EACH_QUESTION }
export { TIME_PLAY_GAME }
export { TIME_PLAY_GAME_FILL }
export { MimeType }
export { MAXIMUM_HARDWORKING_PERCENT }
export { MaximumRatingSubject }
export { StarRanking }
export { HELP_LINK }
